import React from 'react';

const AddRecipe = () => {

  return (
    <div className="pa2">
     <button className="product__button" type="button" >ADD RECIPE</button>
    </div>
  )
}

export default AddRecipe;